// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import { useNavigate } from "react-router-dom";
// import "./styles/Login.css";
// import loginbg from "../assets/loginbg.png";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import Icons from "../components/icons";

// const Login = () => {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);

//   const validateEmail = (value) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(value);
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!email) newErrors.email = "Email is required";
//     else if (!validateEmail(email)) newErrors.email = "Invalid email format";
//     if (!password) newErrors.password = "Password is required";
//     else if (password.length < 6)
//       newErrors.password = "Password must be 6+ characters";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const newErrors = validateForm();

//     if (Object.keys(newErrors).length === 0) {
//       setIsLoading(true);
//       try {
//         const response = await fetch("/api/auth/login", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ email, password }),
//         });

//         const json = await response.json();

//         if (response.ok && json?.data?.token) {
//           // ✅ Save token to localStorage
//           localStorage.setItem("token", json.data.token);

//           // ✅ Save user data to localStorage
//           if (json.data.user) {
//             localStorage.setItem("user", JSON.stringify(json.data.user));
//           }

//           // Clear form
//           setEmail("");
//           setPassword("");
//           setErrors({});

//           // Navigate to dashboard
//           navigate("/dashboard", { replace: true });
//         } else {
//           // Handle error response
//           const errorMessage =
//             json?.message || "Login failed. Please try again.";
//           setErrors({ submit: errorMessage });
//         }
//       } catch (error) {
//         console.error("Login error:", error);
//         setErrors({ submit: "Connection error. Please check your network." });
//       } finally {
//         setIsLoading(false);
//       }
//     } else {
//       setErrors(newErrors);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword((prev) => !prev);
//   };

//   const handleForgotPassword = () => {
//     navigate("/forgot-password");
//   };

//   return (
//     <div className="login-wrapper ">
//       <div className="login-left ">
//         <img
//           src={loginbg}
//           alt="QwickHub illustration - Team collaboration"
//           className="w-full h-auto object-cover"
//         />
//         <p>
//           Unleash Your Team's Potential With QwickHub <br />
//           Built For Modern Product Teams
//         </p>
//       </div>

//       <div className="login-right ">
//         <div className="absolute top-4 right-6 flex items-center gap-0 cursor-pointer">
//           <Icons.Logo />
//           <span className="text-xl font-semibold">QwickHub</span>
//         </div>

//         <div className="login-card">
//           <h2 className="title text-3xl font-semibold p-5">Login</h2>
//           <p className="subtitle center ">Hi, Welcome Back!</p>

//           <form onSubmit={handleSubmit} noValidate>
//             {/* Submit error message */}
//             {errors.submit && (
//               <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
//                 <p className="text-sm text-red-600">{errors.submit}</p>
//               </div>
//             )}

//             <div className="form-group">
//               <label htmlFor="email">Email</label>

//               <div className="password-field p-x-5">
//                 <input
//                   id="email"
//                   type="email"
//                   placeholder="Enter Your Email"
//                   value={email}
//                   onChange={(e) => {
//                     setEmail(e.target.value);
//                     if (errors.email)
//                       setErrors((prev) => ({ ...prev, email: "" }));
//                     if (errors.submit)
//                       setErrors((prev) => ({ ...prev, submit: "" }));
//                   }}
//                   disabled={isLoading}
//                   aria-invalid={errors.email ? "true" : "false"}
//                   aria-describedby={errors.email ? "email-error" : undefined}
//                 />
//               </div>

//               {errors.email && (
//                 <span id="email-error" className="error-text">
//                   {errors.email}
//                 </span>
//               )}
//             </div>

//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <div className="password-field">
//                 <input
//                   id="password"
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Enter Your Password"
//                   value={password}
//                   onChange={(e) => {
//                     setPassword(e.target.value);
//                     if (errors.password)
//                       setErrors((prev) => ({ ...prev, password: "" }));
//                     if (errors.submit)
//                       setErrors((prev) => ({ ...prev, submit: "" }));
//                   }}
//                   disabled={isLoading}
//                   aria-invalid={errors.password ? "true" : "false"}
//                   aria-describedby={
//                     errors.password ? "password-error" : undefined
//                   }
//                 />
//                 <button
//                   type="button"
//                   onClick={togglePasswordVisibility}
//                   disabled={isLoading}
//                   aria-label={showPassword ? "Hide password" : "Show password"}
//                   className="toggle-password-btn"
//                 >
//                   {showPassword ? <FaEye /> : <FaEyeSlash />}
//                 </button>
//               </div>
//               {errors.password && (
//                 <span id="password-error" className="error-text">
//                   {errors.password}
//                 </span>
//               )}
//             </div>

//             <div className="login-links-row">
//               <span className="contact-text">
//                 Any Queries? Contact{" "}
//                 <a href="https://qwickbit.com/"> Qwickbit</a>
//               </span>

//               <button
//                 type="button"
//                 onClick={handleForgotPassword}
//                 disabled={isLoading}
//                 className="forgot-link-inline"
// Login.propTypes = {
//   // Login component doesn't require props
// };

// export default Login;

/**
 * ─────────────────────────────────────────────
 * src/pages/Login.js  (REPLACE your existing)
 * ─────────────────────────────────────────────
 *
 * WHAT CHANGED vs your original:
 * BEFORE: Had fetch(), setIsLoading, try/catch all inside this file
 * AFTER:  All of that is in Redux. This component just:
 *           1. Reads state with useAuth()
 *           2. Dispatches actions with login()
 *           3. Watches for success/error and responds in UI
 *
 * KEY CONCEPT — useEffect for navigation:
 * We use useEffect to WATCH the success/error state from Redux.
 * When isAuthenticated becomes true (login succeeded),
 * useEffect runs and navigates to /dashboard.
 *
 * WHY useEffect and not just after dispatch()?
 * Because dispatch() is async. The state doesn't update instantly.
 * useEffect watches the state variable and reacts AFTER it updates.
 *
 * DATA FLOW:
 * handleSubmit → login(credentials) → Redux thunk → axios → backend
 *      ↓ (response comes back)
 * Redux updates: isAuthenticated=true OR loginError="..."
 *      ↓
 * useEffect sees isAuthenticated changed → navigate('/dashboard')
 * OR JSX sees loginError changed → shows error message
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import useAuth from "../hooks/useAuth";
import Icons from "../components/icons";
import loginbg from "../assets/loginbg.png";
import "./styles/Login.css";


const Login = () => {
  const navigate = useNavigate();

  // ── Local UI state ────────────────────────
  // These stay local because they're pure UI concerns.
  // The actual login logic and errors live in Redux.
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [localErrors, setLocalErrors] = useState({}); // form validation errors

  // ── Redux state and actions via our custom hook ──
  const {
    login,
    isLoginLoading,
    loginError,
    isAuthenticated,
    clearErrors,
    clearReset,
  } = useAuth();

  // ─────────────────────────────────────────
  // EFFECT: Navigate when login succeeds
  // Also clears the reset session data when user logs in
  // ─────────────────────────────────────────
  useEffect(() => {
    if (isAuthenticated) {
      clearReset(); // Clear any OTP/reset session data
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─────────────────────────────────────────
  // EFFECT: Clear Redux errors when user types
  // UX improvement: as soon as they start correcting,
  // the backend error message disappears.
  // ─────────────────────────────────────────
  useEffect(() => {
    if (email || password) {
      clearErrors();
    }
  }, [email, password]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Client-side form validation ───────────
  // This runs BEFORE we even call the API.
  // Saves unnecessary network requests.
  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) newErrors.email = "Email is required";
    else if (!emailRegex.test(email)) newErrors.email = "Invalid email format";

    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setLocalErrors(validationErrors);
      return;
    }

    setLocalErrors({}); // clear validation errors

    // ── This is the ONLY line needed to log in ──
    // Everything else (loading state, token saving, error handling)
    // is handled by the Redux thunk and authSlice reducers.
    login({ email, password });
    // After this, useEffect above watches isAuthenticated
    // and navigates when it becomes true.
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <div className="login-wrapper ">
      <div className="login-left ">
        <img
          src={loginbg}
          alt="QwickHub illustration - Team collaboration"
          className="w-full h-auto object-cover"
        />
        <p>
          Unleash Your Team's Potential With QwickHub <br />
          Built For Modern Product Teams
        </p>
      </div>

      <div className="login-right ">
        <div className="absolute top-4 right-6 flex items-center gap-0 cursor-pointer">
          <Icons.Logo />
          <span className="text-xl font-semibold">QwickHub</span>
        </div>

        <div className="login-card">
          <h2 className="title text-3xl font-semibold p-5">Login</h2>
          <p className="subtitle center">Hi, Welcome Back!</p>

          <form onSubmit={handleSubmit} noValidate>
            {/*
              Backend error from Redux.
              loginError is set by the rejected reducer in authSlice.
              It shows the message your backend returned (e.g. "Invalid email or password.")
            */}
            {loginError && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
                <p className="text-sm text-red-600">{loginError}</p>
              </div>
            )}

            {/* Email field */}
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <div className="password-field p-x-5">
                <input
                  id="email"
                  type="email"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (localErrors.email)
                      setLocalErrors((prev) => ({ ...prev, email: "" }));
                  }}
                  disabled={isLoginLoading}
                  aria-invalid={localErrors.email ? "true" : "false"}
                />
              </div>
              {localErrors.email && (
                <span className="error-text">{localErrors.email}</span>
              )}
            </div>

            {/* Password field */}
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-field">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Your Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (localErrors.password)
                      setLocalErrors((prev) => ({ ...prev, password: "" }));
                  }}
                  disabled={isLoginLoading}
                  aria-invalid={localErrors.password ? "true" : "false"}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  disabled={isLoginLoading}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  className="toggle-password-btn"
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
              {localErrors.password && (
                <span className="error-text">{localErrors.password}</span>
              )}
            </div>

            <div className="login-links-row">
              <span className="contact-text">
                Any Queries? Contact{" "}
                <a href="https://qwickbit.com/"> Qwickbit</a>
              </span>

              <button
                type="button"
                onClick={handleForgotPassword}
                className="forgot-link-inline"
              >
                Forgot Password?
              </button>
            </div>

            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

Login.propTypes = {
  // Login component doesn't require props
};

export default Login;
